import { z } from 'zod';
import { EventType } from '../../../types/events';

/**
 * NB!
 * If you need to change the schema, please also update the backend repository as it uses the same schema.
 * Otherwise the backend will reject the requests.
 */

const baseSchema = z.object({
  name: z.string().min(1),
  date: z.string().min(1),
  time: z.string().min(1),
  description: z.string().min(1),
  property: z.string().min(1),
});

/**
 * Event invite schema is a bit different for different eventTypes.
 * Some fields are used in all schemas, even though their label texts might
 * differ. e.g. name field is used for name of event / subject of community meeting.
 */
export const schema = z.discriminatedUnion('eventType', [
  baseSchema.extend({
    eventType: z.literal(EventType.CommunityMeeting),
    location: z.string().min(1),
    regards: z.string(),
  }),
  baseSchema.extend({
    eventType: z.literal(EventType.CommunityWorkDay),
    contactPerson: z.string(),
  }),
  baseSchema.extend({
    eventType: z.literal(EventType.OtherEvent),
    contactPerson: z.string(),
  }),
  baseSchema.extend({
    eventType: z.literal(EventType.Party),
    contactPerson: z.string(),
  }),
]);

export type EventInviteFormState = z.infer<typeof schema>;
